import { isAfter, isBefore, parseISO } from 'date-fns'
import * as Yup from 'yup'

import { formValidationSchemaNoChanged } from '../../../../../Form'
import {
  getIsListingPublicationInProgressError,
  LISTING_PUBLICATION_IN_PROGRESS_ERROR_KEY,
} from '../../../../../RentalPortalListing'
import { parseListingFormDate } from '../../../../RentalPortal.utils'

import { LISTING_PUBLICATION_SCHEDULE_FIELD_NAME } from './ListingPublicationScheduleModal.constants'

function getIsListingPublicationScheduleInOrder({ bounds, value }) {
  const isAfterLowerBound =
    !bounds.after || isAfter(value, parseISO(bounds.after))

  const isBeforeUpperBound =
    !bounds.before || isBefore(value, parseISO(bounds.before))

  return !value || (isAfterLowerBound && isBeforeUpperBound)
}

export function getListingPublicationScheduleInitialValues({
  timezone,
  value,
}) {
  return {
    [LISTING_PUBLICATION_SCHEDULE_FIELD_NAME]: parseListingFormDate(
      value,
      timezone
    ),
  }
}

export function getListingPublicationSchedulePayload({
  [LISTING_PUBLICATION_SCHEDULE_FIELD_NAME]: value,
}) {
  return value ? new Date(value).toISOString() : null
}

export function getListingPublicationScheduleValidationSchema({
  bounds,
  initialValues,
  t,
}) {
  return Yup.object({
    [LISTING_PUBLICATION_SCHEDULE_FIELD_NAME]: Yup.date()
      .nullable()
      .required(t('RentalPortal.ListingPublicationScheduleRequiredKey'))
      .test({
        message: t('RentalPortal.ListingPublicationScheduleInPastKey'),
        name: 'listingPublicationScheduleInFuture',
        test: value => !value || isAfter(value, new Date()),
      })
      .test({
        message: t('RentalPortal.ListingFormDeactivateBeforeGoLiveKey'),
        name: 'listingPublicationScheduleInOrder',
        test: value =>
          getIsListingPublicationScheduleInOrder({ bounds, value }),
      }),
  }).concat(formValidationSchemaNoChanged({ initialValues }))
}

export function getListingPublicationScheduleErrorKey(error) {
  return getIsListingPublicationInProgressError(error)
    ? LISTING_PUBLICATION_IN_PROGRESS_ERROR_KEY
    : 'RentalPortal.ListingPublicationScheduleSaveErrorKey'
}
